module.exports = __webpack_public_path__ + "img/icon-6.abfb7f6f.png";